// Every hazard's felt-report table now carries its own submitted_by /
// verification_status / verified_by / merged_into fields (see
// common.models.ReviewableMixin on the backend) instead of one centralized
// reports table. This config is what lets ONE admin page work against all
// nine without duplicating the same list/review/merge UI nine times - pick
// a module, and its base URL + field names drive everything below.
export const backendUrl = (process.env.REACT_APP_BACKEND_API_URL_LOCAL || "").replace(/\/$/, "");

const REVIEWABLE_MODULES = [
    {
        key: "cyclone", label: "Cyclone",
        base: `${backendUrl}/cyclone/cyclone-felt-reports/`,
        dateField: "date_cyclone", descField: "additional_info",
        locationFields: ["municipality", "sub_municipality", "suco"],
        hasAdvisory: true,
    },
    {
        key: "flood", label: "Flood",
        base: `${backendUrl}/flood/flood-felt-reports/`,
        dateField: "date_flood", descField: "additional_info",
        locationFields: ["municipality", "sub_municipality", "suco"],
        hasAdvisory: true,
    },
    {
        key: "landslide", label: "Landslide",
        base: `${backendUrl}/landslide/landslide-felt-reports/`,
        dateField: "date_landslide", descField: "additional_info",
        locationFields: ["municipality", "sub_municipality", "suco"],
        hasAdvisory: true,
    },
    {
        key: "earthquake", label: "Earthquake",
        base: `${backendUrl}/EarthQuake/eq-felt-reports/`,
        dateField: "date_time", descField: "message",
        locationFields: ["municipality", "sub_municipality", "suco"],
        hasAdvisory: true,
    },
    {
        key: "lightning", label: "Lightning",
        base: `${backendUrl}/lightning/lightning-felt-reports/`,
        dateField: "date_lightning", descField: "additional_info",
        locationFields: ["municipality", "sub_municipality", "suco"],
        hasAdvisory: true,
    },
    {
        key: "firerisk", label: "Fire",
        base: `${backendUrl}/firerisk/firerisk-felt-reports/`,
        dateField: "date_fire", descField: "additional_info",
        locationFields: ["municipality", "sub_municipality", "suco"],
        hasAdvisory: true,
    },
    {
        key: "road_accident", label: "Road Accident",
        base: `${backendUrl}/roadaccident/road-accident-reports/`,
        dateField: "datetime", descField: "message",
        locationFields: ["municipality", "submunicipality", "suco"],
        hasAdvisory: true,
    },
    {
        key: "road_condition", label: "Road Condition",
        base: `${backendUrl}/roadaccident/road-condition-reports/`,
        dateField: "date_time", descField: "message",
        locationFields: ["municipality", "submunicipality", "suco"],
        hasAdvisory: false,
    },
    {
        key: "black_spot", label: "Black Spot",
        base: `${backendUrl}/roadaccident/black-spot-reports/`,
        dateField: "datetime", descField: null,
        locationFields: ["municipality", "submunicipality", "suco"],
        hasAdvisory: false,
    },
];

export const ADVISORY_OPTIONS = ["Low", "Moderate", "High", "Very High"];

// Fields every module carries via ReviewableMixin - never shown in the
// generic "other details" dump since they already have dedicated UI.
export const REVIEWABLE_META_FIELDS = new Set([
    "id", "submitted_by", "submitted_by_detail", "verification_status",
    "verified_by", "verified_by_detail", "verified_at", "merged_into",
    "report_group_count", "photo", "image", "image_url", "image_content_type",
]);

export const moduleByKey = (key) => REVIEWABLE_MODULES.find((m) => m.key === key);

export default REVIEWABLE_MODULES;
